export const LTV_COEFFICIENT_KEY = 'ltv_coef';

export const DEFAULT_LTV_COEFFICIENT = 1;
